import React from 'react';
import ConfirmModal from '../../common/ConfirmModal';

export default function ModalSendToHead({
  show, onClose, onConfirm, strategyNum,
}) {
  return (
    <ConfirmModal
      show={show}
      onClose={onClose}
      onConfirm={onConfirm}
      headerText="Отправка проекта"
      message={`Проект будет сохранен и направлен руководителю ${strategyNum || 'СП'}, убедитесь, что поля заполнены верно. Отменить действие будет нельзя`}
    />
  );
}
